import { category } from '../jsonEditor/categoryJsonEditorConfig.js';
import { versionConfig, statusConfig, regionConfig, languageConfig, categoryTypeConfig, } from '../options.js';
export const categories = {
    type: 'categories',
    contentType: 'category',
    editor: 'json',
    editorTitle: { name: 'title', placeholder: 'title' },
    editorConfig: category,
    editorContext: 'root',
    supportContent: ['categories'],
    title: 'Category',
    plural: 'Categories',
    endpoint: 'categories',
    queryProperties: ['id', 'status', 'title', 'type', 'slug', 'region', 'language', 'client'],
    version: versionConfig,
    versionType: [
        { label: 'Category', value: 'category' },
        { label: 'Curated Category', value: 'curatedCategory' },
        { label: 'Milestone', value: 'milestone' },
        { label: 'Action Item', value: 'actionItem' },
    ],
    listing: {
        type: 'grid',
        gridColumns: ['title', 'type'],
        gridCombineProperty: 'slug',
        gridContentType: 'categories',
        gridDecode: ['title'],
        gridFilters: [
            {
                label: 'Status',
                key: 'status',
                uppercase: false,
                default: false,
                value: 'published',
                options: statusConfig.options,
            },
            {
                label: 'Region',
                key: 'region',
                uppercase: false,
                default: true,
                options: regionConfig.options,
            },
            {
                label: 'Language',
                key: 'language',
                uppercase: false,
                default: true,
                options: languageConfig.options,
            },
            {
                label: 'Type',
                key: 'type',
                uppercase: false,
                default: true,
                options: categoryTypeConfig.options,
            },
        ],
        gridHasChildren: true,
        gridJoin: { properties: [] },
        gridSearch: [{ key: 'title', combine: true }],
        gridSupportContent: [],
    },
    sidebar: {
        status: [
            {
                label: 'Status',
                name: 'status',
                input: 'select',
                options: [
                    { label: 'Draft', value: 'draft' },
                    { label: 'Pending', value: 'pending' },
                    { label: 'Publish', value: 'published' },
                ],
            },
        ],
        version: [
            { label: 'Slug', name: 'slug', input: 'text' },
            { label: 'Client', name: 'client', input: 'multiselect' },
            regionConfig,
            languageConfig,
        ],
        versioned: true,
    },
    meta: [
        {
            label: 'Priority',
            name: 'priority',
            input: 'number',
            description: 'Please enter the category priority number with 100 being the highest and 0 being the lowest.',
        },
        {
            label: 'Legacy ID',
            name: '_legacyId',
            input: 'number',
            description: 'Legacy ID for the document (if applicable).',
        },
    ],
    validate: [],
};
//# sourceMappingURL=categories.js.map